import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Card, Col, Form, Typography, Input, Modal, Radio, Row, Upload } from 'antd'
import { useDeepEffect } from '../../../utils/hooks'

const BrandForm = (props) => {
  const { formDataBrand, setFormDataBrand, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formDataBrand)) {
      setFieldsValue({
        name: formDataBrand.name,
        nameEng: formDataBrand.nameEng,
        address: formDataBrand.address,
        taxId: formDataBrand.taxId
      })
    }
  }, [formDataBrand])
  
  return (
    <Card>
      <Form form={form} layout="vertical">
        <Form.Item label="ชื่อไทย">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataBrand({ ...formDataBrand , name: event.target.value })
          } />)}
        </Form.Item>
        <Form.Item label="ชื่ออังกฤษ">
          {getFieldDecorator(`nameEng`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataBrand({ ...formDataBrand ,nameEng: event.target.value })
          } />)}
        </Form.Item>
        <Form.Item label="ที่อยู่">
          {getFieldDecorator(`address`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataBrand({ ...formDataBrand ,address: event.target.value })
          } />)}
        </Form.Item>
        <Form.Item label="เลขนิติบุคคล">
          {getFieldDecorator(`taxId`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataBrand({ ...formDataBrand ,taxId: event.target.value })
          } />)}
        </Form.Item>
      </Form>
    </Card>
  )
}
const WrappedBrandForm = Form.create({ name: 'BrandForm' })(
  BrandForm
)
export default WrappedBrandForm



// WEBPACK FOOTER //
// ./src/pages/CreateBrand/BrandForm/index.js